<script>
import SidePanel from './side-panel/side-panel.vue';
import { EventBus } from '@utils/event-bus';
import { h } from 'vue';

export default {
    name: 'SidePanelWrapper',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        renderContent: {
            type: Function,
            default: () => () => null,
        },
    },
    watch: {
        isOpen (val) {
            if (val === false) {
                EventBus.$emit('sidePanelClosed');
            }
        },
    },
    render () {
        if (this.isOpen) {
            const content = this.renderContent?.() || null;

            if (content) {
                return h('div', { class: 'side-panel-container' }, [
                    h(
                        SidePanel,
                        {},
                        {
                            header: () => content?.children?.header,
                            body: () => content?.children?.body,
                        },
                    ),
                ]);
            }
        }

        return '';
    },
};
</script>

<style scoped></style>
